import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

/** Old Canceled URL — send people to History. */
export default class CoachingCoachSessionsCanceledRoute extends Route {
  @service declare router: RouterService;

  beforeModel(): void {
    this.router.replaceWith('coaching.coach.sessions.past');
  }
}
